import React, { Fragment, useContext, useEffect, useState } from "react";

import { LoadingContext } from "../Context";
import { AlbumAssetType, AlbumType, BaseRouteParams } from "../Structures";
import { TransactionGetAlbum } from "../Services/Transactions";
import { useNavigate, useParams } from "react-router";
import { formatDate, Toast } from "../Utils";
import { Modal } from "../Components/Modal";
import { Tag } from "../Components/Base";

const Album = () => {
  const navigate = useNavigate();
  const params = useParams<BaseRouteParams>();
  const { setLoading } = useContext(LoadingContext);

  // ==========================================================================================================

  const [album, setAlbum] = useState<AlbumType | null>(null);
  const [selectedAsset, setSelectedAsset] = useState<AlbumAssetType | null>(
    null
  );

  // ==========================================================================================================

  useEffect(() => {
    window.scrollTo(0, 0);
    if (params.id) {
      setLoading(true);
      TransactionGetAlbum(params.id)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            setAlbum(res.data!);
          } else {
            navigate("/gallery");
            Toast("error", res.message);
          }
        })
        .finally(() => setLoading(false));
    } else {
      navigate("/gallery");
    }
  }, []);

  // ==========================================================================================================

  return (
    <Fragment>
      <section className="pt-4 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                style={{ backgroundColor: "#E9EFFD" }}
                className="align-items-center d-md-flex p-3 p-sm-4 mb-3 text-center text-md-start rounded-3"
              >
                <div className="mb-2 mb-md-0 me-0 me-md-4">
                  <div className="avatar mx-auto avatar-xxl">
                    <img
                      className="avatar-img rounded-circle"
                      src={album?.thumbnail}
                      alt={album?.title}
                    />
                  </div>
                </div>

                <div>
                  <div className="mb-2 d-flex justify-content-md-start  justify-content-center align-items-center">
                    {album?.categories.map((tag) => (
                      <Tag key={tag.id} tag={tag} />
                    ))}
                  </div>
                  <h2 className="m-0 mb-3">{album?.title}</h2>
                  <ul className="list-inline mt-1">
                    <li className="list-inline-item">
                      <i className="bi bi-calendar me-1"></i>
                      {album?.create_date
                        ? formatDate(album?.create_date)
                        : "----"}
                    </li>
                  </ul>
                  <p className="my-2 text-justify">{album?.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative pt-4">
        {album?.assets.length ? (
          <div className="container">
            <h3>تصاویر و فیلم‌های مربوطه</h3>
            <hr />
            <div className="row filter-container overflow-hidden">
              {album?.assets.map((asset) => (
                <div
                  onClick={() => setSelectedAsset(asset)}
                  key={asset.id}
                  className="col-sm-6 d-flex justify-content-center align-items-center cursor-pointer col-lg-4 grid-item"
                >
                  <div className="card w-100 rounded-1 mb-4">
                    <div className="card-fold position-relative overflow-hidden rounded-1">
                      {asset.file_type == "image" ? (
                        <img
                          className="card-img"
                          src={asset.file}
                          alt="Gallery asset"
                        />
                      ) : (
                        <div className="w-100 position-relative d-flex justify-content-center align-items-center">
                          <video
                            className="card-img"
                            src={asset.file}
                            preload="metadata"
                          />
                          <div className="position-absolute play-btn d-flex justify-content-center align-items-center rounded-circle bg-white">
                            <i className="bi rotate-90 bi-triangle-fill fs-6" />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </section>
      {selectedAsset ? (
        <Modal close={() => setSelectedAsset(null)}>
          <div className="z-index-99 bg-transparent overflow-hidden mw-520 mb-4">
            <div className="card-fold overflow-hidden position-relative rounded-3">
              {selectedAsset.file_type == "image" ? (
                <img
                  className="card-img"
                  src={selectedAsset.file}
                  alt="Card image"
                />
              ) : (
                <video controls src={selectedAsset.file} preload="metadata" />
              )}
            </div>
          </div>
        </Modal>
      ) : null}
    </Fragment>
  );
};

export default Album;
